import { app } from '../../../../app';
import { Controller } from './registration-services-form.controller';

app.component('registrationServicesForm', {
    bindings: {
        registrationServicesConfiguration: '<',
        onChange: '&',
        onEnter: '&',
    },
    controller: Controller,
    templateUrl: require('./registration-services-form.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/configuration/registration-services-form.component.js